import { render, staticRenderFns } from "./PriceSelection.vue?vue&type=template&id=2ad946b2&scoped=true"
import script from "./PriceSelection.vue?vue&type=script&lang=js"
export * from "./PriceSelection.vue?vue&type=script&lang=js"
import style0 from "./PriceSelection.vue?vue&type=style&index=0&id=2ad946b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad946b2",
  null
  
)

export default component.exports